<template>
  <div>
    <div class="row" v-for="(row, index) of value">
      <div class="col-md-4">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><button class="btn btn-primary" v-bind:disabled="disabled" style="height: 10px;" @click.prevent="deleteRow(index)">X</button>&nbsp; Country</div>
          </div>
          <select class="form-control" v-model="row.country" v-bind:disabled="disabled" @change="onCountryChanged(row)">
            <option v-for="country in searchOptions[index].countries" v-bind:value="country.id" :key="country.id">{{country.text}}</option>
          </select>
        </div>
      </div>

      <div class="col-md-4">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">State</div>
          </div>
          <select class="form-control" v-model="row.state" v-bind:disabled="disabled" @change="onStateChanged(row)">
            <option v-for="state in searchOptions[index].states" v-bind:value="state.id" :key="state.id">{{state.state}}</option>
          </select>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">City</div>
          </div>
          <select class="form-control" v-model="row.city" v-bind:disabled="disabled" @change="onCityChanged(row)">
            <option v-for="city in searchOptions[index].cities" v-bind:value="city.id" :key="city.id">{{city.city}}</option>
          </select>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-3 mx-auto"><button class="btn btn-primary" v-bind:disabled="disabled" style="width: 100%;" @click.prevent="onNewLocation()">New Location</button></div>
    </div>
  </div>
</template>

<script>
  import { countries } from "../util/geotargets.js";
  
  export default {

    props: {
      value: Array,
      disabled: Boolean
    },
    
    data() {
      return {
        
      };
    },
    
    methods: {
      onNewLocation() {
        this.value.push({
          id: 2840,
          country: 2840,
          state: 0,
          city: 0
        });
        
        this.$emit('input', this.value);
      },
      
      deleteRow(index) {
        this.value.splice(index, 1);
      },
      
      onCountryChanged(row) {
        row.state = 0;
        row.city = 0;
        this.$emit('input', this.value);
      },
      
      onStateChanged(row) {
        row.city = 0;
        this.$emit('input', this.value);
      },
      
      onCityChanged(row) {
        this.$emit('input', this.value);
      },
      
      selectFromId(row) {
        // country
        for(const country of countries) {
          if(country.id == id) {
            this.cmbSearchCountry = country.code;
            this.cmbSearchState = "";
            this.cmbSearchCity = "";
            return true;
          }
          
          // state
          for(const state of country.states) {
            if(state.id == id) {
              this.cmbSearchCountry = country.code;
              this.cmbSearchState = state.state;
              this.cmbSearchCity = "";
              return true;
            }
            
            // city
            for(const city of state.cities) {
              if(city.id == id) {
                this.cmbSearchCountry = country.code;
                this.cmbSearchState = state.state;
                this.cmbSearchCity = city.city;
                return true;
              }
            }
          }
        }
      }
    },
    
    computed: {
      searchOptions() {
        return this.value.map((row) => {
          const selCountries = row.country ? countries.filter((country) => country.id == row.country) : [];
          const stateList = selCountries.length > 0 ? selCountries[0].states : [];
          const selStates = row.state ? stateList.filter((state) => state.id == row.state) : [];
          const cityList = selStates.length > 0 ? selStates[0].cities : [];
          
          // make sure cities are sorted
          cityList.sort((a, b) => a.city.localeCompare(b.city, 'en', { sensitivity: 'base' }));
          
          return {
            countries: [
              {
                text: "United States",
                id: 2840
              },
              {
                text: "Canada",
                id: 2124
              },
              {
                text: "United Kingdom",
                id: 2826
              },
              {
                text: "Other",
                id: 1
              }
            ],
            states: [ { id: 0, state: "Not Selected" } ].concat(stateList),
            cities: [ { id: 0, city: "Not Selected" } ].concat(cityList)
          };
        });
      }
    },
    
    watch: {
      value(to, from) {
        let valueUpdated = false;
        
        for(const row of to) {
          if(row.id && (row.country === undefined || row.state === undefined || row.city === undefined)) {
            row = this.selectFromId(row);
            
            valueUpdated = true;
          }
          else if(row.id === undefined) {
            row = this.findId(row);
            
            valueUpdated = true;
          }
        }
        
        if(valueUpdated) {
          this.$emit('input', to);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SearchLocation.vue